import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54320028")

_pushScopeId("data-v-54320028")
const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg"
}
const _hoisted_2 = {
  ref: "heroWave1",
  transform: "translate(0,110)",
  fill: "var(--yellow-400)",
  d: "M0,64L120,90.7C240,117,480,171,720,165.3C960,160,1200,96,1320,64L1440,32L1440,\n      320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
}
const _hoisted_3 = {
  ref: "heroWave2",
  transform: "translate(0,90)",
  fill: "var(--yellow-500)",
  d: "M0,192L120,208C240,224,480,256,720,240C960,224,1200,160,1320,128L1440,96L1440,\n      320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
}
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg"
}
const _hoisted_5 = {
  ref: "servicesWave1",
  transform: "translate(20, 80)",
  fill: "var(--blue-300)",
  d: "M0,128L26.7,106.7C53.3,85,107,43,160,48C213.3,53,267,107,320,117.3C373.3,128,\n      427,96,480,117.3C533.3,139,587,213,640,218.7C693.3,224,747,160,800,128C853.3,96,\n      907,96,960,117.3C1013.3,139,1067,181,1120,208C1173.3,235,1227,245,1280,213.3C1333.3,\n      181,1387,107,1413,69.3L1440,32L1440,320L1413.3,320C1386.7,320,1333,320,1280,\n      320C1226.7,320,1173,320,1120,320C1066.7,320,1013,320,960,320C906.7,320,853,320,\n      800,320C746.7,320,693,320,640,320C586.7,320,533,320,480,320C426.7,320,373,320,\n      320,320C266.7,320,213,320,160,320C106.7,320,53,320,27,320L0,320Z"
}
const _hoisted_6 = {
  ref: "servicesWave2",
  transform: "translate(0, 50)",
  fill: "var(--blue-200)",
  d: "M0,32L26.7,69.3C53.3,107,107,181,160,202.7C213.3,224,267,192,320,192C373.3,\n      192,427,224,480,208C533.3,192,587,128,640,112C693.3,96,747,128,800,117.3C853.3,\n      107,907,53,960,37.3C1013.3,21,1067,43,1120,48C1173.3,53,1227,43,1280,64C1333.3,\n      85,1387,139,1413,165.3L1440,192L1440,320L1413.3,320C1386.7,320,1333,320,1280,\n      320C1226.7,320,1173,320,1120,320C1066.7,320,1013,320,960,320C906.7,320,853,320,\n      800,320C746.7,320,693,320,640,320C586.7,320,533,320,480,320C426.7,320,373,320,\n      320,320C266.7,320,213,320,160,320C106.7,320,53,320,27,320L0,320Z"
}
const _hoisted_7 = {
  ref: "servicesWave3",
  transform: "translate(0, 60)",
  fill: "var(--blue-100)",
  d: "M0,96L26.7,101.3C53.3,107,107,117,160,133.3C213.3,149,267,171,320,186.7C373.3,\n      203,427,213,480,186.7C533.3,160,587,96,640,74.7C693.3,53,747,75,800,101.3C853.3,\n      128,907,160,960,149.3C1013.3,139,1067,85,1120,64C1173.3,43,1227,53,1280,85.3C1333.3,\n      117,1387,171,1413,197.3L1440,224L1440,320L1413.3,320C1386.7,320,1333,320,1280,\n      320C1226.7,320,1173,320,1120,320C1066.7,320,1013,320,960,320C906.7,320,853,320,\n      800,320C746.7,320,693,320,640,320C586.7,320,533,320,480,320C426.7,320,373,320,\n      320,320C266.7,320,213,320,160,320C106.7,320,53,320,27,320L0,320Z"
}
const _hoisted_8 = {
  ref: "servicesWave4",
  transform: "translate(0, 60)",
  fill: "var(--blue-50)",
  d: "M0,96L26.7,80C53.3,64,107,32,160,37.3C213.3,43,267,85,320,122.7C373.3,160,427,\n      192,480,176C533.3,160,587,96,640,85.3C693.3,75,747,117,800,128C853.3,139,907,117,\n      960,122.7C1013.3,128,1067,160,1120,165.3C1173.3,171,1227,149,1280,154.7C1333.3,160,\n      1387,192,1413,208L1440,224L1440,320L1413.3,320C1386.7,320,1333,320,1280,320C1226.7,\n      320,1173,320,1120,320C1066.7,320,1013,320,960,320C906.7,320,853,320,800,320C746.7,\n      320,693,320,640,320C586.7,320,533,320,480,320C426.7,320,373,320,320,320C266.7,320,\n      213,320,160,320C106.7,320,53,320,27,320L0,320Z"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("path", {
  transform: "translate(0, 100), scale(1.4, 1)",
  fill: "var(--blue-50)",
  d: "M0,96L0,320L27,320C53,320 106.7,320 160,320C213,320 266.7,320 320,320C373,320 426.7,320 480,320C533,320 586.7,320 640,320C693,320 746.7,320 800,320C853,320 906.7,320 960,320C1013,320 1066.7,320 1120,320C1173,320 1226.7,320 1280,320C1333,320 1386.7,320 1413.3,320L1440,320L1440,224L1413,208C1387,192 1333.3,160 1280,154.7C1227,149 1173.3,171 1120,165.3C1067,160 1013.3,128 960,122.7C907,117 853.3,139 800,128C747,117 693.3,75 640,85.3C587,96 533.3,160 480,176C427,192 373.3,160 320,122.7C267,85 213.3,43 160,37.3C107,32 53.3,64 26.7,80L0,96"
}, null, -1)
const _hoisted_10 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg"
}
const _hoisted_11 = {
  ref: "aboutWave1",
  fill: "var(--yellow-400)",
  d: "M0,192L60,192C120,192,240,192,360,186.7C480,181,600,171,720,138.7C840,107\n      ,960,53,1080,53.3C1200,53,1320,107,1380,133.3L1440,160L1440,320L1380,320C1320\n      ,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,\n      320,120,320,60,320L0,320Z"
}
const _hoisted_12 = {
  ref: "aboutWave2",
  fill: "var(--blue-500)",
  d: "M0,128L60,106.7C120,85,240,43,360,\n      48C480,53,600,107,720,160C840,213,960,267,1080,256C1200,245,1320,171,1380,\n      133.3L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,\n      720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
}
const _hoisted_13 = {
  ref: "aboutWave3",
  fill: "var(--blue-400)",
  d: "M0,256L60,240C120,224,240,192,360,192C480,192,600,224,720,224C840,224,960,\n      192,1080,181.3C1200,171,1320,181,1380,186.7L1440,192L1440,320L1380,320C1320,\n      320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,\n      320,120,320,60,320L0,320Z"
}
const _hoisted_14 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg"
}
const _hoisted_15 = {
  ref: "reviewsWave2",
  fill: "var(--yellow-300)",
  d: "M0,32L48,48C96,64,192,96,288,133.3C384,171,480,213,576,240C672,267,768,277,864,256C960,235,1056,181,1152,149.3C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
}
const _hoisted_16 = {
  ref: "reviewsWave1",
  fill: "var(--yellow-200)",
  d: "M0,256L48,256C96,256,192,256,288,240C384,224,480,192,576,197.3C672,203,768,245,864,266.7C960,288,1056,288,1152,272C1248,256,1344,224,1392,208L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
}
const _hoisted_17 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg"
}
const _hoisted_18 = {
  ref: "bonusesWave1",
  fill: "var(--blue-100)",
  d: "M0,192L48,202.7C96,213,192,235,288,213.3C384,192,480,128,576,122.7C672,117,768,171,864,202.7C960,235,1056,245,1152,245.3C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
}
const _hoisted_19 = {
  ref: "bonusesWave2",
  fill: "var(--blue-300)",
  transform: "translate(0, 50), scale(1.8, 1)",
  d: "M0,192L48,202.7C96,213,192,235,288,213.3C384,192,480,128,576,122.7C672,117,768,171,864,202.7C960,235,1056,245,1152,245.3C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
}
const _hoisted_20 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg"
}
const _hoisted_21 = {
  ref: "directorWave1",
  transform: "translate(0,110)",
  fill: "var(--yellow-400)",
  d: "M0,64L120,90.7C240,117,480,171,720,165.3C960,160,1200,96,1320,64L1440,32L1440,\n      320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
}
const _hoisted_22 = {
  ref: "directorWave2",
  transform: "translate(0,90)",
  fill: "var(--yellow-500)",
  d: "M0,192L120,208C240,224,480,256,720,240C960,224,1200,160,1320,128L1440,96L1440,\n      320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
}
const _hoisted_23 = {
  ref: "directorWave3",
  transform: "translate(0,60)",
  fill: "var(--blue-400)",
  "fill-opacity": "1",
  d: "M0,128L120,154.7C240,181,480,235,720,245.3C960,256,1200,224,1320,208L1440,\n      192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
}
const _hoisted_24 = {
  key: 6,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg"
}
const _hoisted_25 = {
  ref: "stepsDrop1",
  transform: "translate(100, 100)",
  fill: "var(--blue-100)",
  d: "M38.2,-3.7C47.9,17.4,53.1,48.8,40,59.2C27,69.7,-4.3,59.3,-22.4,43.2C-40.6,27.1,-45.7,5.3,-39.8,-10.6C-33.8,-26.5,-16.9,-36.5,-1.3,-36C14.3,-35.6,28.5,-24.8,38.2,-3.7Z"
}
const _hoisted_26 = {
  ref: "stepsDrop2",
  transform: "translate(1340, 100)",
  fill: "var(--blue-200)",
  d: "M61.1,-26.6C65.1,-7.7,44.3,12.4,20.3,30.4C-3.7,48.5,-31.1,64.4,-49.8,54.2C-68.6,43.9,-78.8,7.5,-69.1,-19.3C-59.4,-46.1,-29.7,-63.3,-0.5,-63.1C28.6,-63,57.2,-45.4,61.1,-26.6Z"
}
const _hoisted_27 = {
  ref: "stepsDrop3",
  transform: "translate(1210, 60), scale(.7,.8)",
  fill: "var(--blue-100)",
  d: "M48.8,-20.8C52.7,-4.1,37.8,13.8,16.9,30.8C-4.1,47.8,-31.1,63.9,-43.3,56C-55.5,48,-52.8,15.8,-43.1,-9C-33.4,-33.8,-16.7,-51.3,2.9,-52.3C22.5,-53.2,45,-37.6,48.8,-20.8Z"
}
const _hoisted_28 = {
  ref: "stepsWave1",
  transform: "translate(0, 100)",
  fill: "var(--blue-200)",
  d: "M0,192L60,192C120,192,240,192,360,186.7C480,181,600,171,720,138.7C840,107\n      ,960,53,1080,53.3C1200,53,1320,107,1380,133.3L1440,160L1440,320L1380,320C1320\n      ,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,\n      320,120,320,60,320L0,320Z"
}
const _hoisted_29 = {
  ref: "stepsWave2",
  transform: "translate(0,60)",
  fill: "var(--blue-300)",
  "fill-opacity": "1",
  d: "M0,128L120,154.7C240,181,480,235,720,245.3C960,256,1200,224,1320,208L1440,\n      192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
}
const _hoisted_30 = {
  key: 7,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  class: "wf-screen-bg wf-bg-yellow-200"
}
const _hoisted_31 = {
  ref: "vimeoWave1",
  fill: "var(--blue-100)",
  d: "M0,128L48,144C96,160,192,192,288,181.3C384,171,480,117,576,128C672,139,768,213,864,218.7C960,224,1056,160,1152,160C1248,160,1344,224,1392,256L1440,288L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
}
const _hoisted_32 = {
  ref: "vimeoWave2",
  fill: "var(--blue-300)",
  transform: "rotate(180 720 160)",
  d: "M0,192L48,202.7C96,213,192,235,288,213.3C384,192,480,128,576,122.7C672,117,768,171,864,202.7C960,235,1056,245,1152,245.3C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Waypoint = _resolveComponent("Waypoint")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Waypoint, {
      tag: 'tspan',
      onChange: _cache[1] || (_cache[1] = (e) => _ctx.waypointChange('top', _ctx.id, e))
    }),
    (_ctx.id === 'hero' || _ctx.id === 'newyear')
      ? (_openBlock(), _createBlock("svg", _hoisted_1, [
          _createVNode("path", _hoisted_2, null, 512),
          _createVNode("path", _hoisted_3, null, 512),
          _createVNode("path", {
            ref: "heroWave3",
            transform: "translate(0,60)",
            fill: _ctx.id === 'newyear' ? 'var(--pink-600)' : 'var(--blue-50)',
            "fill-opacity": "1",
            d: "M0,128L120,154.7C240,181,480,235,720,245.3C960,256,1200,224,1320,208L1440,\n      192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
          }, null, 8, ["fill"])
        ]))
      : _createCommentVNode("", true),
    (['services', 'preferences'].includes(_ctx.id))
      ? (_openBlock(), _createBlock("svg", _hoisted_4, [
          _createVNode("path", _hoisted_5, null, 512),
          _createVNode("path", _hoisted_6, null, 512),
          _createVNode("path", _hoisted_7, null, 512),
          _createVNode("path", _hoisted_8, null, 512),
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    (_ctx.id === 'about')
      ? (_openBlock(), _createBlock("svg", _hoisted_10, [
          _createVNode("path", _hoisted_11, null, 512),
          _createVNode("path", _hoisted_12, null, 512),
          _createVNode("path", _hoisted_13, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.id === 'reviews')
      ? (_openBlock(), _createBlock("svg", _hoisted_14, [
          _createVNode("path", _hoisted_15, null, 512),
          _createVNode("path", _hoisted_16, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.id === 'bonuses')
      ? (_openBlock(), _createBlock("svg", _hoisted_17, [
          _createVNode("path", _hoisted_18, null, 512),
          _createVNode("path", _hoisted_19, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.id === 'director')
      ? (_openBlock(), _createBlock("svg", _hoisted_20, [
          _createVNode("path", _hoisted_21, null, 512),
          _createVNode("path", _hoisted_22, null, 512),
          _createVNode("path", _hoisted_23, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.id === 'steps')
      ? (_openBlock(), _createBlock("svg", _hoisted_24, [
          _createVNode("path", _hoisted_25, null, 512),
          _createVNode("path", _hoisted_26, null, 512),
          _createVNode("path", _hoisted_27, null, 512),
          _createVNode("path", _hoisted_28, null, 512),
          _createVNode("path", _hoisted_29, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.id === 'vimeo')
      ? (_openBlock(), _createBlock("svg", _hoisted_30, [
          _createVNode("path", _hoisted_31, null, 512),
          _createVNode("path", _hoisted_32, null, 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Waypoint, {
      tag: 'tspan',
      onChange: _cache[2] || (_cache[2] = (e) => _ctx.waypointChange('bottom', _ctx.id, e))
    })
  ], 64))
})